module.exports = __webpack_public_path__ + "img/header-logo.0bcd42ed.png";